<template>
	<div>
		<input type="hidden" :value="calcularValores">
		<div class="col-12 col-sm-12 col-md-12 col-lg-12">
			<div class="table-finanzas">
				<CLoader :pConfigLoad="ConfigLoad">
					<template slot="BodyFormLoad">
						<table class="table-fin-05">
							<thead>
								<tr>
									<th class="sticky mediana marca"><b>Descripción</b></th>
									<th class="mediana text-center">Plan</th>
									<th class="mediana text-center">%</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in ListaDetalle" :key="index">
									<td :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' ">
										<b>{{item.Descripcion}}</b>
									</td>
									<template>
										<td v-if="item.Descripcion === 'Facturacion'" :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan" />  </td>
										<td v-if="item.Descripcion === 'Materiales'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Equipos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Mano de Obra'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Vehiculos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Contratistas'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Viaticos'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
										<td v-if="item.Descripcion === 'Burden'"><Cmoneda :activo="false" :minus="true" :clase="'form-control form-finanza form-control-sm text-center bold'"  currency="$" separator="," :precision="2" v-model="item.MontoPlan"/>  </td>
									</template>
									<td v-if="item.Descripcion === 'Facturacion' " :class="item.Descripcion === 'Facturacion' ? 'sticky borde_bajo' : 'sticky' "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Materiales'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Equipos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Mano de Obra'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Vehiculos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Contratistas'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Viaticos'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
									<td v-if="item.Descripcion === 'Burden'  "><Cporcentaje :activo="true" :minus="true" :clase="'bold form-control form-finanza form-control-sm text-center'"  currency="%" separator="," :precision="2" v-model="item.PorcentPlan"/> </td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td class="color-01 bold sticky marca">Costo Operacional</td>
									<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="CostoOpPlan"/></td>
									<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="CostoOpPlanPorcent"/></td>
								</tr>
								<tr>
									<td class="color-01 bold sticky marca">Gross Profit</td>
									<td><Cmoneda 	 :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="$" separator="," :precision="2" v-model="GpPlan"/></td>
									<td><Cporcentaje :activo="true" :minus="true" :clase="'form-control form-finanza form-control-sm color-01 bold text-center'"  currency="%" separator="," :precision="2" v-model="GpPlanPorcent"/></td>
								</tr>
							</tfoot>
						</table>
					</template>
				</CLoader>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props:['poBtnSave'],
	data() {
		return {
			Modal:true,
            FormName:'Spend Plan',
            EmitSeccion:this.poBtnSave.EmitSeccion,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			ListaDetalle:[
				{Descripcion:'Facturacion',MontoPlan:0,PorcentPlan:100},
				{Descripcion:'Equipos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Materiales',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Mano de Obra',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Vehiculos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Viaticos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Burden',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Contratistas',MontoPlan:0,PorcentPlan:0},
			],
			CostoOpPlan:'',
            CostoOpPlanPorcent:'',
            GpPlan:'',
			GpPlanPorcent:'',
			SpendPlan:{
            },
			IdCotizacionServicio:''
		}
	},
	methods: {
		Limpiar(){
			this.ListaDetalle=[
				{Descripcion:'Facturacion',MontoPlan:0,PorcentPlan:100},
				{Descripcion:'Equipos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Materiales',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Mano de Obra',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Vehiculos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Viaticos',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Burden',MontoPlan:0,PorcentPlan:0},
				{Descripcion:'Contratistas',MontoPlan:0,PorcentPlan:0},
			];
			this.CostoOpPlan='';
            this.CostoOpPlanPorcent='';
            this.GpPlan='';
			this.GpPlanPorcent='';
		},
		Guardar(){
			this.bus.$emit('GuardarSpendPlan',this.ListaDetalle);
			this.$toast.success('Plan Guardado Correctamente');
			$('#'+this.EmitSeccion).modal('hide');
		},
		RecuperarSpendPlan(){
			this.$http.get('cotizacion_servicio/recovery', {
				params:{
					IdCotizacionServicio: this.IdCotizacionServicio
				}
			}).then((res)=>{
				const Obj=res.data.data.cotizacion_servicio;
				this.ListaDetalle[0].MontoPlan=Obj.ValorVenta;
				this.ListaDetalle[1].MontoPlan=Obj.TotalEquipos;
				this.ListaDetalle[2].MontoPlan=Obj.TotalMateriales;
				this.ListaDetalle[3].MontoPlan=Obj.TotalManoDeObra;
				this.ListaDetalle[4].MontoPlan=Obj.TotalCostoKm;
				this.ListaDetalle[5].MontoPlan=Obj.TotalViaticos;
				this.ListaDetalle[6].MontoPlan=Obj.CostoBurden;
				this.ListaDetalle[7].MontoPlan=Obj.TotalContratistas;
			}).finally(()=>{
				this.ConfigLoad.ShowLoader=false;
			})
		},
		getPorcent($monto,$montoDivisor){
			let PORCENTAJE_FINA = 0;
			if (parseFloat($monto)  > 0) {
				if (parseFloat($montoDivisor) > 0){
					let decimal = ( parseFloat($monto) / parseFloat($montoDivisor) );
					let porcenTemp= (decimal * 100);
					porcenTemp = porcenTemp.toFixed(2);
					PORCENTAJE_FINA = (porcenTemp > 100) ? 100 : porcenTemp;
				}
			}
			return PORCENTAJE_FINA;
		}
	},
	created() {
		this.bus.$off('NewModal_'+this.EmitSeccion);
		this.bus.$on('NewModal_'+this.EmitSeccion,(IdCotizacionServicio,SpendPlan,TipoSpendPlan)=>{
			this.ConfigLoad.ShowLoader=true;
			this.IdCotizacionServicio=IdCotizacionServicio;
			if (SpendPlan.length==0 && TipoSpendPlan=='1') {
				this.RecuperarSpendPlan();
			}
			else{
				if (TipoSpendPlan=='2') {
					this.Limpiar();
				}
				this.ConfigLoad.ShowLoader=false
			}
			this.bus.$off("Save_"+this.EmitSeccion);
            this.bus.$on("Save_"+this.EmitSeccion, () => {
				this.Guardar();
			});
		});
	},
	computed:{
		calcularValores(){
			let PlanFacturacion = 0;
			let CostoOpPlan = 0;
			for(let i=0;i<this.ListaDetalle.length;i++){
				if(i>0){
					if(this.ListaDetalle[i].Descripcion != '') {
						if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
							CostoOpPlan += 0;
						}else {
							CostoOpPlan += parseFloat(this.ListaDetalle[i].MontoPlan);
						}
						// PORCENTAJE DE COLUMNA DE PLAN DE FACTURACIÓN
						this.ListaDetalle[i].PorcentPlan = this.getPorcent(this.ListaDetalle[i].MontoPlan, PlanFacturacion);
                    }
				}
				else {

                    if( isNaN(this.ListaDetalle[i].MontoPlan) ) {
						PlanFacturacion += 0;
                    }else {
						PlanFacturacion += parseFloat(this.ListaDetalle[i].MontoPlan);
					}
                }
			}
			this.CostoOpPlan 				= CostoOpPlan.toFixed(2);
			this.CostoOpPlanPorcent 		= this.getPorcent(CostoOpPlan, PlanFacturacion);
			let montoGP						= (PlanFacturacion - CostoOpPlan);
			this.GpPlan 					= montoGP;
			this.GpPlanPorcent				= this.getPorcent (montoGP, PlanFacturacion);
		}
	}
}
</script>

<style>

</style>
